// extracted by mini-css-extract-plugin
export default {"primary":"var(--primary-color)"};